import Badge from "@/components/core/badge.tsx";
import DataTable, { type ColumnDef } from "@/components/core/data-table.tsx";
import Pagination from "@/components/core/pagination.tsx";
import { Searchbar } from "@/components/core/searchbar.tsx";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/core/tabs.tsx";
import { Content } from "@/components/layouts/content";
import { Header } from "@/components/layouts/header";
import type { FormTemplate } from "@/data/form-templates";
import { formTemplateQueryOptions } from "@/features/dashboard/api/queries/form-templates-query";
import { useSuspenseQuery } from "@tanstack/react-query";
import { Link, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/form-templates")({
	component: Page,
});

// const search = Route.useSearch();

const getFile = (item: FormTemplate) => {
	const typeFolder = item.type.toLowerCase();
	// const url = `https://sc-admin.revlv.com/forms/${typeFolder}/${item.folder_category}/${item.filename}.docx`;
	const url = "";

	window.open(url, "_blank");
};

const columns: ColumnDef<FormTemplate>[] = [
	{
		id: "title",
		label: "Title",
		cell: ({ data }) => (
			<Link
				to="/form-templates/$formId"
				params={{
					formId: data.filename,
				}}
				className="font-semibold text-blue-600 hover:text-blue-500"
			>
				{data.title}
			</Link>
		),
	},
	{
		id: "type",
		label: "Type",
		cell: ({ data }) => data.type,
	},
	{
		id: "category",
		label: "Category",
		cell: ({ data }) => data.category,
	},
	// {
	//   id: 'filename',
	//   label: 'Updated',
	//   cellClassName: 'text-right',
	//   headerClassName: 'text-right',
	//   cell: ({ data }) => formatDate(data.updated_at),
	// },
];

// const formTemplatesQuery = useSuspenseQuery(
//   formTemplateQueryOptions({
//     ...search,
//     type: "judicial"
//   }),
// );

function Page() {
	return (
		<Content>
			<Header />
			<div className="flex flex-col w-full max-w-[1200px] p-6">
				<div className="flex flex-col w-full gap-3">
					<Tabs defaultValue="account">
						<TabsList>
							<TabsTrigger value="account">Judicial</TabsTrigger>
							<TabsTrigger value="security">Civil Procedure</TabsTrigger>
							<TabsTrigger value="sessions">Criminal</TabsTrigger>
						</TabsList>
						<TabsContent value="account">
							<div className="flex flex-col w-full gap-2">
								<Searchbar />
								<DataTable
									data={[]}
									columns={columns}
									onEdit={(item) => {
										// console.log(item);
										getFile(item);
									}}
									onRowClick={() => {}}
								/>
								<Pagination
									onClick={() => {
										alert("Wow");
									}}
									initialPage={1}
									pageCount={4}
								/>
							</div>
						</TabsContent>
					</Tabs>
				</div>
				{/*<FullCalendar plugins={[dayGridPlugin]} initialView="dayGridMonth" />*/}
			</div>
		</Content>
	);
}
